import { Injectable } from "@angular/core";
import { getCurrencySymbol } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class CsvService {
  downloadFile(data: any, filename = "data") {
    const csvData = this.convertToCSV(data, [
      "Date",
      "UserName",
      "EmailID",
      "PackageType",
      "TransactionType",
      "InvoiceNumber",
      "TransactionID",
      "ISExclusive",
      "StartTime",
      "EndTime",
      "PackageAmount",
      "totalPaid",
      "ApplicationFee",
      "StripeFees",
      "RefundedAmount",
      "AssetId",
      "AssetName",
      "CouponCodeType",
      "CouponCode",
      "RideTime",
      "BasePrice",
      "WithoutVat",
      "VatPercentage",
      "Vat",
      "NetReceived",
      "Currency",
      "StartAddress",
      "EndAddress",
    ]);
    this.triggerDownload(csvData, filename);
  }

  downloadAdvanceFile(data: any, filename = "data") {
    const formattedData = this.formatAddressesInData(data);

    const csvData = this.convertToCSV(formattedData, [
      "Purchase Date",
      "Package Title",
      "UserName",
      "Email ID",
      "Mobile",
      "User Address",
      "Asset Type",
      "Package Type",
      "Fees",
      "Deposite",
      "Extra Charge Fee",
      "Brand Name",
      "Total Asset Allowed",
      "Duration",
      "Timing",
      "Vat",
      "Time Slot",
      "Start Date",
      "End Date",
      "Status",
    ]);
    this.triggerDownload(csvData, filename);
  }

  downloadRatingFile(data: any, filename = "data") {
    const formattedData = this.formatAddressesInData(data);

    const csvData = this.convertToCSV(formattedData, [
      "Created Date",
      "UserName",
      "Email ID",
      "Mobile",
      "User Address",
      "Average Rating",
      "Brand Name",
      "Comment",
    ]);
    this.triggerDownload(csvData, filename);
  }

  private formatAddressesInData(data: any[]): any[] {
    return data.map((item) => {
      const formattedItem = { ...item };

      if (
        formattedItem["User Address"] &&
        typeof formattedItem["User Address"] === "string"
      ) {
        const addressParts = formattedItem["User Address"]
          .split(",")
          .map((part) => part.trim());

        if (addressParts.length > 4) {
          const firstPart = addressParts.slice(0, 4).join(", ");
          const secondPart = addressParts.slice(4).join(", ");
          formattedItem["User Address"] = `${firstPart},\n${secondPart}`;
        }
      }

      return formattedItem;
    });
  }

  private triggerDownload(csvData: string, filename: string): void {
    const blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const dwldLink = document.createElement("a");

    const isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;

    if (isSafariBrowser) {
      dwldLink.setAttribute("target", "_blank");
    }

    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  private convertToCSV(objArray: any, headerList: string[]): string {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let csvContent = "";

    let headerRow = "Sno";
    headerList.forEach((header) => {
      headerRow += ',"' + header.replace(/"/g, '""') + '"';
    });
    csvContent += headerRow + "\r\n";

    for (let i = 0; i < array.length; i++) {
      let line = (i + 1).toString();

      for (const header of headerList) {
        let cellValue = array[i][header] ?? "";

        if (
          typeof cellValue === "string" &&
          (cellValue.includes(",") ||
            cellValue.includes('"') ||
            cellValue.includes("\n") ||
            cellValue.includes("\r"))
        ) {
          cellValue = '"' + cellValue.replace(/"/g, '""') + '"';
        }

        line += "," + cellValue;
      }

      csvContent += line + "\r\n";
    }

    return csvContent;
  }
}
